import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { SubscriptionActionsHostWrapper } from 'commerce-subscription-lib/public/components';
import { InvoiceCreation } from 'commerce-subscription-lib/public/types';
import { isNone } from 'commerce-subscription-lib/public/utilities';
import { usePermissionsContext } from '../context/PermissionsContext';
import { useSubscriptionHighlight } from '../hooks/useSubscriptionHighlight';
import { EditableTitle } from './EditableTitle';
import { SubscriptionProperties } from './SubscriptionProperties';
import { SubscriptionSidebarActions } from './SubscriptionSidebarActions';
import { NoEditPermissionsAlert } from './alerts/NoEditPermissionsAlert';
import { RedAlertBanner } from './alerts/RedAlertBanner';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function SubscriptionHighlight({
  objectId,
  editableAreas
}) {
  const {
    canEditSubject,
    readOnly,
    closeSidebar
  } = usePermissionsContext();
  const {
    data,
    loading,
    error
  } = useSubscriptionHighlight(objectId);
  if (loading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      "data-test-id": "highlight-spinner",
      minHeight: 126,
      grow: true,
      layout: "centered"
    });
  }
  if (!data || error) {
    var _error$message;
    throw new Error(`Error in Subscription highlight component query, ${JSON.stringify((_error$message = error === null || error === void 0 ? void 0 : error.message) !== null && _error$message !== void 0 ? _error$message : error)}`);
  }
  const {
    name,
    status,
    customer,
    lastModifiedDate,
    upcomingLineItems,
    invoiceCreation,
    nextPaymentDate,
    collectionProcess
  } = data;
  const doesNotHaveContactAssociatedEmail = isNone(customer) || !customer.email;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [canEditSubject && !readOnly && /*#__PURE__*/_jsx(SubscriptionActionsHostWrapper, {
      objectId: Number(objectId),
      closeSidebar: closeSidebar,
      children: /*#__PURE__*/_jsx(SubscriptionSidebarActions, {
        invoiceCreation: invoiceCreation
      })
    }), !canEditSubject && !readOnly && /*#__PURE__*/_jsx(NoEditPermissionsAlert, {}), /*#__PURE__*/_jsx(EditableTitle, {
      objectId: objectId,
      title: name,
      isEditable: canEditSubject && !readOnly
    }), /*#__PURE__*/_jsx(SubscriptionProperties, {
      objectId: objectId,
      status: status,
      lastModifiedDate: lastModifiedDate,
      upcomingLineItems: upcomingLineItems,
      editableAreas: editableAreas,
      nextPaymentDate: nextPaymentDate,
      collectionProcess: collectionProcess
    }), doesNotHaveContactAssociatedEmail && invoiceCreation === InvoiceCreation.On && /*#__PURE__*/_jsx(RedAlertBanner, {
      "data-test-id": "no-associated-email-alert",
      message: "subscriptions.NoAssociatedContactEmailAlert.highlightCardMessage"
    })]
  });
}
export default SubscriptionHighlight;